import { render, staticRenderFns } from "./TreatmentProcedure.vue?vue&type=template&id=607bfb7e"
import script from "./TreatmentProcedure.vue?vue&type=script&lang=js"
export * from "./TreatmentProcedure.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports